import { useEffect } from "react";
import { Messages } from "namirasoft-account-client";
import { NSAHomePage, NSARouterMakerResult } from "namirasoft-account-react";
import { AccountLayout } from "../AccountLayout";
import { AccountRouterProps } from "../AccountRouterProps";

export default function HomePage(props: NSARouterMakerResult & AccountRouterProps)
{
    let onLogin = () =>
    {
        if (window.opener)
        {
            let token = props.account.token_manager?.getValue();
            window.opener.postMessage(JSON.stringify(Messages.login(token ?? "")), "*");
            window.close();
        }
    };

    useEffect(() =>
    {
        onLogin();
        // eslint-disable-next-line
    }, [props]);

    return (
        <AccountLayout
            {...props}
        >
            <NSAHomePage
                {...props}
            />
        </AccountLayout>
    );
}